import { useEffect } from 'react'
import { leaveToMarketingSite } from './leave'

/** Rendered for every location the Vue router used to bounce: it leaves, and shows nothing meanwhile. */
export function Leaving() {
  useEffect(() => {
    leaveToMarketingSite()
  }, [])
  return null
}
